const SET_IS_SLIDE_RENDER_IN_PROGRESS = 'SET_IS_SLIDE_RENDER_IN_PROGRESS'

const _state = {
  isSlideRenderInProgress: false, // Forces Slide component re-render on slideActive change
}

const _getters = {
  isSlideRenderInProgress(state) {
    return state.isSlideRenderInProgress
  },
}

const _mutations = {
  [SET_IS_SLIDE_RENDER_IN_PROGRESS](state, value) {
    state.isSlideRenderInProgress = value
  },
}

const _actions = {
  setSlideRenderInProgressAction({ commit }, value) {
    commit(SET_IS_SLIDE_RENDER_IN_PROGRESS, value)
  },
}

export default {
  namespaced: true,
  state: _state,
  getters: _getters,
  actions: _actions,
  mutations: _mutations,
}
